import React, { useEffect, useRef, useState } from "react";

interface Option {
  label: string;
  value: string;
}

interface Props {
  index: number;
  title: string;
  note: string;
  options: Option[];
  onChange: (selected: string[], removed: string[]) => void;
  selected?: string[];
  error?: string;
  disabled?: boolean;
  // onClose: () => void;
}

const MultiSelectCounterDropdown = ({ index, title, note, options, onChange, selected, error, disabled = false }: Props) => {
  const [selectedValues, setSelectedValues] = useState<string[]>(selected || []);
  const [open, setOpen] = useState(false);

  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!popupRef.current) {
      return;
    }
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupRef]);

  const toggleSelect = (value: string) => {
    let newSelected;
    let removed: string[] = [];

    if (selectedValues.includes(value)) {
      newSelected = selectedValues.filter(v => v !== value);
      removed = [value];
    } else {
      newSelected = [...selectedValues, value];
    }

    setSelectedValues(newSelected);
    onChange(newSelected, removed);
  };

  useEffect(() => {
    setSelectedValues(selected as string[]);
  }, [selected]);

  return (
    <div className={`flex flex-col w-full space-y-2 ${disabled ? "text-skgray" : ""}`}>
      <div id="titledata" className={"flex items-center pb-[5px]"}>
        <span>{index && <span className="content_count">{index}</span>}</span>
        {title && <span className="content_title">{title}</span>}
      </div>
      {note && <div className="notes-class-content !my-[0px]">{note}</div>}
      <div ref={popupRef} className="relative w-64 text-sm">
        <div onClick={() => setOpen(!open)} tabIndex={0} className="flex items-center justify-between px-4 py-2 border cursor-pointer rounded-xl">
          <span>{selectedValues.length > 0 ? `${selectedValues.length} Selected` : "Select options"}</span>
          <svg
            className="w-4 h-4 ml-2 transition-transform transform"
            style={{ transform: open ? "rotate(180deg)" : "" }}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>

        {open && (
          <div className="absolute z-10 w-full mt-1 overflow-y-auto bg-white border rounded shadow max-h-60">
            {options.map(opt => (
              <div
                key={opt.value}
                onClick={() => !disabled && toggleSelect(opt.value)}
                className={`px-4 py-2 cursor-pointer hover:bg-gray-100 flex items-center ${
                  selectedValues.includes(opt.value) ? "bg-gray-100 font-medium" : ""
                }`}
              >
                <input type="checkbox" checked={selectedValues.includes(opt.value)} readOnly className="mr-2" />
                {opt.label}
              </div>
            ))}
          </div>
        )}
      </div>
      {error && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{error}</span>}
    </div>
  );
};

export default MultiSelectCounterDropdown;
